import { Label } from '@cian/ui-kit';

import { type FC } from 'react';

type DepositPropertyLabelProps = {
  trackLabelClick?(): void;
};

export const DepositPropertyLabel: FC<DepositPropertyLabelProps> = props => {
  return (
    <Label
      background="overlay-control-default"
      color="theme-black"
      data-testid="publisher-labels.deposit-property"
      onClick={props.trackLabelClick}
    >
      Залоговая недвижимость
    </Label>
  );
};
